import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { OriginalPlanInfo } from '../../types/generated/Plan.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetOriginalPlanQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetOriginalPlanQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, subscription: { __typename?: 'AccountSubscription', id: string, originalPlan?: { __typename?: 'Plan', cost: number, eligibility: Types.PlanEligibility, enterprise?: boolean | null, id: string, name?: string | null, period: Types.PlanPeriod, tier: Types.PlanTier, title: string, userLimit?: number | null, version?: number | null } | null } } | null };


export const GetOriginalPlan = /*#__PURE__*/ gql`
    query GetOriginalPlan($accountId: ID!) {
  account(accountId: $accountId) {
    ...OriginalPlanInfo
  }
}
    ${OriginalPlanInfo}` as unknown as DocumentNode<GetOriginalPlanQuery, GetOriginalPlanQueryVariables>;

          

          export const useGetOriginalPlanQuery = (options?:QueryHookOptions<GetOriginalPlanQuery, GetOriginalPlanQueryVariables>) => useQuery(GetOriginalPlan, options);

          

          export type GetOriginalPlanQueryOptions = QueryHookOptions<GetOriginalPlanQuery, GetOriginalPlanQueryVariables>;

          

          export const useGetOriginalPlanLazyQuery = (options?:LazyQueryHookOptions<GetOriginalPlanQuery, GetOriginalPlanQueryVariables>) => useLazyQuery(GetOriginalPlan, options);

          

          export type GetOriginalPlanQueryResult = ReturnType<typeof useGetOriginalPlanQuery>;

          
